import { createFileRoute } from '@tanstack/react-router';
import { EditAccount } from '../../pages/EditAccount';

export const Route = createFileRoute('/_authenticated/account/edit')({
  component: EditAccount,
});

